"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootEstateSagas = exports.watchPhaseLabelClickToScroll = exports.watchInitPhaseMap = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var EstateAction_1 = require("@/pages/estate/actions/EstateAction");
var effects_1 = require("redux-saga/effects");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var WindowApi_1 = require("@/api/browser/WindowApi");
var PlaceSaga_1 = require("@/pages/place/sagas/PlaceSaga");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var EstateMapAction_1 = require("@/pages/estate/actions/EstateMapAction");
var PlaceAvailableSaga_1 = require("@/pages/place/sagas/PlaceAvailableSaga");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var RootTrendsSaga_1 = require("@/pages/common/sagas/RootTrendsSaga");
var RootTransactionsSaga_1 = require("@/pages/common/sagas/RootTransactionsSaga");
var getFullGallery = function (state) { return state.estate.images; };
var getPhaseById = function (state, id) { return state.estate.phases.find(function (it) { return it.id === id; }); };
var getBlockFromIndex = function (state, i) { return state.estate.blocks[i]; };
var getActivePhase = function (state) {
    return {
        phase: state.estate.phases.find(function (it) { return it.active; }) || null,
        i: state.estate.phases.findIndex(function (it) { return it.active; }) || -1,
    };
};
var getContainerWidth = function (id) {
    var elementId;
    return __generator(this, function (_a) {
        elementId = document.getElementById(id);
        if (!elementId)
            return [2 /*return*/, false];
        return [2 /*return*/, elementId.clientWidth];
    });
};
var getCurrentSort = function (state, filterType) {
    return filterType === SfilterTypeGroup_1.SfilterType.BUY ? state.estate.availableSaleSort :
        state.estate.availableRentSort;
};
var getCurrentOrder = function (state, filterType) {
    return filterType === SfilterTypeGroup_1.SfilterType.BUY ? state.estate.availableSaleOrder :
        state.estate.availableRentOrder;
};
var sortToggleSaga = PlaceSaga_1.watchSortToggle(getCurrentSort, getCurrentOrder);
var isStickyAtTop = function (parentOffset) {
    var stickyTop;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.getStickyTop, 'stickymenu')];
            case 1:
                stickyTop = _a.sent();
                if (stickyTop === null)
                    return [2 /*return*/];
                if (!(parentOffset > stickyTop)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.setSticky(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(EstateAction_1.default.setSticky(false))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
};
var watchFullSize = function () {
    var payload, containerWidthFull, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(EstateAction_1.default.ESTATE_FULL_SIZE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(getContainerWidth, 'app')];
            case 2:
                containerWidthFull = _a.sent();
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.setFullGalleryWidth(containerWidthFull + "px"))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.showPop(PlaceState_1.GalleryPopState.FULL))];
            case 4:
                _a.sent();
                index = payload;
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.setGalleryIndex(index))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchImageClick = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var payload, src, galleryItems, matchedIndex;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(EstateAction_1.default.ESTATE_ON_IMAGE_CLICK)];
                            case 1:
                                payload = (_a.sent()).payload;
                                src = payload;
                                return [4 /*yield*/, effects_1.select(getFullGallery)];
                            case 2:
                                galleryItems = _a.sent();
                                matchedIndex = galleryItems.findIndex(function (it) { return it === src; });
                                if (!(matchedIndex === -1)) return [3 /*break*/, 4];
                                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, '#locations')];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, effects_1.put(EstateAction_1.default.fullsize(matchedIndex))];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnPropertyEnquireClicked = function () {
    var action, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_PROPERTY_ENQUIRE_CLICKED)];
            case 1:
                action = _a.sent();
                item = action.payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(item))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnPropertyLinkClicked = function () {
    var action, link;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_PROPERTY_LINK_CLICKED)];
            case 1:
                action = _a.sent();
                link = action.payload;
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(link))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSelectPhase = function () {
    var payload, phaseId, phase;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(EstateAction_1.default.ESTATE_ON_SELECT_PHASE)];
            case 1:
                payload = (_a.sent()).payload;
                phaseId = payload;
                return [4 /*yield*/, effects_1.select(getPhaseById, phaseId)];
            case 2:
                phase = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, phase.url)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchContactClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EstateAction_1.default.ESTATE_ON_CONTACT_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchInitPhaseMap = function () {
    var _a, phase, i;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(EstateMapAction_1.default.ESTATE_MAP_ON_MAP_READY)];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.select(getActivePhase)];
            case 2:
                _a = _b.sent(), phase = _a.phase, i = _a.i;
                if (phase === null)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.onLocationLabelClick(phase, i))];
            case 3:
                _b.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.watchPhaseLabelClickToScroll = function () {
    var payload, phase, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EstateAction_1.default.ESTATE_ON_LOCATION_LABEL_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                phase = payload.phase, i = payload.i;
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollElementToKey, 'blocks', "phase-" + i)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchStickyMenu = function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 1:
                action = _a.sent();
                return [4 /*yield*/, effects_1.call(isStickyAtTop, action.payload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchMapPinClicked = function () {
    var payload, blockIndex, block;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(EstateMapAction_1.default.ESTATE_MAP_ON_PIN_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                blockIndex = payload;
                if (blockIndex === -1)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.select(getBlockFromIndex, blockIndex)];
            case 2:
                block = _a.sent();
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.onSelectBlock(block))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchDomLoaded = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(GlobalCallSaga_1.initLazyLoad)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchChartRangeClicked = function () {
    var payload, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EstateAction_1.default.ESTATE_ON_CHART_RANGE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                index = payload;
                return [4 /*yield*/, effects_1.put(EstateAction_1.default.setChartActiveIndex(index))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var rootEstateSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    rootTrendsSagas: RootTrendsSaga_1.rootTrendsSagas,
    rootTransactionsSagas: RootTransactionsSaga_1.rootTransactionsSagas,
    placeAvailableSagas: PlaceAvailableSaga_1.placeAvailableSagas,
    watchImageClick: watchImageClick,
    watchFullSize: watchFullSize,
    sortToggleSaga: sortToggleSaga,
    watchOnPropertyEnquireClicked: watchOnPropertyEnquireClicked,
    watchOnPropertyLinkClicked: watchOnPropertyLinkClicked,
    watchOnSelectPhase: watchOnSelectPhase,
    watchContactClicked: watchContactClicked,
    watchInitPhaseMap: exports.watchInitPhaseMap,
    watchStickyMenu: watchStickyMenu,
    watchPhaseLabelClickToScroll: exports.watchPhaseLabelClickToScroll,
    watchMapPinClicked: watchMapPinClicked,
    watchDomLoaded: watchDomLoaded,
    watchChartRangeClicked: watchChartRangeClicked,
};
exports.rootEstateSagas = rootEstateSagas;
